import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";

import dots from "../assets/images/dots.svg";

const Section = styled.div`
  position: relative;
  z-index: -1;
`;

const Container = styled.div`
  padding: 0 20px 45px 20px;
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  
  &:after {
    content: '';
    width: 300px;
    height: 300px;
    position: absolute;
    right: calc(50% - 40px);
    top: 50%;
    transform: translateY(-50%); 
    background-image: url('${dots}')
  }
  
  h1 {
    padding: 200px 0;
    margin: 0;
    text-transform: uppercase;
    padding-right: 40px;
    position: relative;
    z-index: 1;
  }
  
  > * {
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
  }

  ${media.tablet`
    padding: 0 20px 35px 20px;
    display: block;
    
    &:after {
      height: 200px;
      right: -20px;
      top: 40px;
    }
    
    h1 {
      padding: 0;
      margin-bottom: 30px;
      width: 100%;
      max-width: 100%;
    }
  `};
`;

const Image = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 15px 0 0 15px;
  position: absolute;
  left: 50%;
  width: 50vw;
  max-width: 50vw;
  flex-basis: 50vw;
  height: calc(100% - 45px);
  mix-blend-mode: multiply;

  ${media.tablet`
    position: relative;
    height: 200px;
    left: 0;
    right: -20px;
    width: calc(100% + 20px);
    max-width: calc(100% + 20px);
    flex-basis: calc(100% + 20px);
  `}
`;

export class SimpleHero extends React.Component {
  render() {
    return (
      <Section className={this.props.componentClass}>
        <Container>
          <h1>{this.props.title}</h1>

          <Image
            style={{
              backgroundImage: `url("${this.props.heroImage}")`
            }}
          />
        </Container>
      </Section>
    );
  }
}
